import { CampaignPageNotificationType } from "../../types";
import useCampaignReporterNotifications from "./useCampaignReporterNotifications";
import useCampaignStatisticNotifications from "./useCampaignStatisticNotifications";

export default function useAsyncCampaignNotifications(): CampaignPageNotificationType[] {
  const reporterNotifications = useCampaignReporterNotifications();
  const statisticNotifications = useCampaignStatisticNotifications();

  return [...reporterNotifications, ...statisticNotifications];
}
